import connection from '@/api/connection'

// export const singIn = async ({ commit }, user) => {
//     tr
// }

export const getPlaces = async ({ commit }) => {
  commit('setPlaceIsLoading', true);
  let url = `/places/selectable`;

  await connection.get(url)
    .then(res => {
      const places = res.data.data;
      commit('setPlacesSelectable', places);
      commit('setPlaceIsLoading', false);
    }).catch(err => {
      console.log('error', err);
      commit('setPlaceIsLoading', false);
    });
}

export const loadPlaces = async ({ commit }, query = null) => {
    let page = 1;
    let search = '';
    let perPage = 25;
    if(query !== null){
      page = query?.page || 1;
      search = query?.search || '';
      perPage = query?.perPage || 25;
    }

    commit('setPlaceIsLoading', true);
    let url = `/places`;
    if (search === '') {
      url = `${url}?page=${page}&perPage=${perPage}`;
    } else {
      url = `${url}?search=${search}&page=${page}&perPage=${perPage}`;
    }

    await connection.get(url)
      .then(res => {
        console.log(res);
        const places = res.data.data;
        commit('setPlaces', places);
        const pagination = {
            totalItems: res.data.totalItems,  // total number of elements or items
            // per_page: res.data.per_page, // items per page
            currentPage: res.data.currentPage, // current page (it will be automatically updated when users clicks on some page number).
            totalPages: res.data.totalPages, // total pages in record

            perPage: res.data.perPage 
        }
        res.data.pagination = pagination;
        commit('setPlacesPaginated', res.data);
        commit('setPlaceIsLoading', false);
      }).catch(err => {
        console.log('error', err);
        commit('setPlaceIsLoading', false);
      });
}

export const placeById = async ({ commit }, id) => {
  commit('setPlaceIsLoading', true);
  await connection.get(`/places/${id}`)
    .then(res => {
      commit('setPlaceDetail', res.data.data);
      commit('setPlaceIsLoading', false);
    }).catch(err => {
      console.log('error', err);
      commit('setPlaceIsLoading', false);
    });
}

export const storePlace = async ({ commit }, place) => {
  commit('setPlaceIsCreating', true);
  await connection.post(`/places/create`, place)
    .then(res => {
      commit('saveNewPlaces', res.data.data);
      commit('setPlaceIsCreating', false);
    }).catch(err => {
      console.log('error', err);
      commit('setPlaceIsCreating', false);
    });
}

export const updatePlace = async ({ commit }, place ) => {
  commit('setPlaceIsUpdating', true);
  await connection.put(`/places/${place.id}/update`, place)
    .then(res => {
      commit('saveUpdatedPlace', res.data.data);
      commit('setPlaceIsUpdating', false);
    }).catch(err => {
      console.log('error', err);
      commit('setPlaceIsUpdating', false);
    });
}

export const deletePlace = async ({ commit }, place) => {
  commit('setPlaceIsDeleting', true);
  await connection.delete(`/places/${place.id}/delete`)
    .then(res => {
      commit('setDeletePlace', res.data.data);
      commit('setPlaceIsDeleting', false);
    }).catch(err => {
      console.log('error', err);
      commit('setPlaceIsDeleting', false);
    });
}
